import React from 'react';

const FloatingButtons = () => {
  return (
    <div style={{
      position: 'fixed',
      bottom: '80px', 
      left: '30px', 
      zIndex: '1000',
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/919765960907" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#25d366',
          color: 'white',
          padding: '10px 18px', // बटन को थोड़ा गोल शेप देने के लिए
          borderRadius: '50%',
          fontSize: '24px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
          transition: 'transform 0.3s',
          textAlign: 'center'
        }}
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Call Button */}
      <a 
        href="tel:+919765960907" 
        style={{
          backgroundColor: '#0d6efd',
          color: 'white',
          padding: '10px 18px',
          borderRadius: '50%',
          fontSize: '24px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
          transition: 'transform 0.3s',
          textAlign: 'center'
        }}
      >
        <i className="fas fa-phone-alt"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;